
import { DistriApiService } from './distri.api.service';
import { Injectable } from '@angular/core';
import { DistriAgent } from 'src/app/model/distri/DistriAgent';

@Injectable({
  providedIn: 'root'
})
export class DistriAgentService {

  constructor(private apiService: DistriApiService) { }

  test() {
    return this.apiService.get('common/test/test');
  }

  getListPaginate(size: number, page: number) {
    return this.apiService.get('common/agents?size=' + size + '&page=' + page);
  }
  update(obj: DistriAgent) {
    return this.apiService.put('common/agents', JSON.stringify(obj));
  }
  save(obj: any) {
    return this.apiService.post('agent/createAgent', obj);
  }

  saveOrUpdate(obj: any) {
    return this.apiService.post('agent/createOrUpdateAgent', obj);
  }

  modifyObjectif(obj: any) {
    return this.apiService.post('agent/modifyObjectif', obj);
  }

  chargerObjectif(formData: FormData) {
    console.log('in call');
    return this.apiService.post('/agent/chargerObjectif', formData);
  }

  chargerDgRevendeur(formData: FormData) {
    console.log('in call');
    return this.apiService.post('/agent/chargerDgRevendeur', formData);
  }

  send() {
    console.log('in call');
    return this.apiService.get('/agent/addFileContent');
  }

  sendDgRevendeur() {
    console.log('in call');
    return this.apiService.get('/agent/addClientFileContent');
  }

  sendDgClient() {
    console.log('in call');
    return this.apiService.get('/agent/addDgClientFileContent');
  }

  findMsisdnByType(login: any, type: any) {
    return this.apiService.get('agent/findMsisdnByType?login=' + login + '&type=' + type);
  }

  findAllZone() {
    return this.apiService.get('agent/findAllZone');
  }

  modify(obj: any) {
    return this.apiService.post('agent/modifyAgent', obj);
  }

  getProfils() {
    return this.apiService.get('agent/findAllProfil');
  }

  getFonctionnalites() {
    return this.apiService.get('agent/findAllFonctionnalite');
  }

  getProfil(id: any) {
    return this.apiService.get('agent/findProfilById?id=' + id);
  }

  saveProfil(obj: any) {
    return this.apiService.post('agent/createProfil', obj);
  }

  editProfil(obj: any) {
    return this.apiService.post('agent/editProfil', obj);
  }

  getAgent() {
    return this.apiService.get('agent/findAllAgent');
  }
  getAgentByLogin(login:string) {
    return this.apiService.get('agent/findByLogin?a='+login);
  }

  getObjectif() {
    return this.apiService.get('agent/findAllObjectif');
  }

  delete(id: any) {
    return this.apiService.get('agent/disableAgent?id=' + id);
  }

  activer(id: any) {
    return this.apiService.get('agent/activeAgent?id=' + id);
  }
}
